/**
 * @overview Color map and helper
 */

/* eslint-disable */
const baseColors = {
  // Teal
  'teal': `#69c8c6`,

  // Blue
  'blue': `#131120`,
  'blue-2': `#94AEBF`,

  // Gray
  'gray': '#888888',
  'gray-2': '#979797',
  'gray-3': '#D8D8D8',
  'light-gray': `#ededed`,

  // Red
  'red': `#ED1F34`,

  // Green
  'lime-green': `#B6FDBF`,

  // Others
  'white': `#FFFFFF`,
  'black': `#000000`,
};

const commonColors = {
  'text': baseColors[`gray`],
};

const colors = { ...baseColors, ...commonColors };

export const color = (name) => {
  return colors[name];
};

export const hexToRGBa = (hex, opacity) => {
  let c;

  if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
    c = hex.substring(1).split(``);

    if (c.length === 3) {
      c = [ c[0], c[0], c[1], c[1], c[2], c[2] ];
    }

    c = `0x` + c.join(``);

    return `rgba(${[ (c >> 16) & 255, (c >> 8) & 255, c & 255 ].join(`, `)}, ${opacity})`;
  }

  // no hex value just return the original value
  return `#${hex}`;
};
